import React from "react";
import E_CustomerProfile from "./e_customer_profile/e_customer_profile";
import E_AccountSummary from "./e_account_summary/e_account_summary";
import E_NetMetering from '../e_home_component/e_tips/e_tips'
import E_UsageSummary from "./e_usage_summary/e_usage_summary";
import E_Tips from "./e_promotions/e_promotions";
import E_RaiseRequest from "../e_self_help/view/_self_help_callus";
import E_BillComparison from "./e_bill_comparison/e_bill_comparison"

const Components = {
    E_CustomerProfile,
    E_AccountSummary,
    E_NetMetering,
    E_UsageSummary,
    E_Tips,
     E_RaiseRequest,
    E_BillComparison
  };
   
  export default block => {
    if (typeof Components[block.widgetRoute] !== "undefined") {
      return React.createElement(Components[block.widgetRoute], {
        block: block
      });
    }
  }